import * as React from 'react';
import JumpList from '../common/JumpList';
import './styles.scss';

interface LanguageSelectOption {
  displayText: string;
  value: string;
}

interface LanguageSelectProps {
  items: LanguageSelectOption[];
  selectedValue: string;
}

const LanguageSelect = ({ items, selectedValue }: LanguageSelectProps) => {
  const action = (option: LanguageSelectOption) => {
    window.location.href = option.value;
  };

  return (
    <div className="language-select">
      <JumpList
        items={items}
        selectedValue={selectedValue}
        action={action}
      />
    </div>
  );
};

export default LanguageSelect;
